import {
	Card,
	CardBody,
	Input,
	Pagination,
	Table,
	TableCell,
	TableContainer,
	TableFooter,
	TableHeader,
	Select,
	Button,
} from '@windmill/react-ui';
import ExportDataExcelBE from 'components/common/ExportDataExcelBE';
import RequestQueueTable from 'components/vehicleRequestQueue/RequestQueueTable';
import TableLoading from 'components/preloader/TableLoading';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext } from 'react';
import VehicleServices from 'services/VehicleServices';
import VehicleDrawer from 'components/drawer/VehicleDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { SidebarContext } from 'context/SidebarContext';
import { FiPlus } from 'react-icons/fi';

const VehicleRequestQueue = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { data, loading } = useAsync(VehicleServices.getAllVehicleRequestQueue);
	const { toggleDrawer } = useContext(SidebarContext);
	const vehicle = data?.data || [];
	const { title, serviceId } = useToggleDrawer();
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const {
		userRef,
		handleChangePage,
		totalResults,
		resultsPerPage,
		dataTable,
		serviceData,
		handleSubmitUser,

		currentPage,
	} = useFilter(vehicle, itemsPerPage);

	return (
		<>
			<DeleteModal id={serviceId} title={title} />
			<MainDrawer>
				<VehicleDrawer id={serviceId} />
			</MainDrawer>
			<PageTitle>
				Vehicle Request Queue List
				<a href="/vehicle">
					<Button className="float-right">Vehicle List</Button>
				</a>
			</PageTitle>

			<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
				<CardBody>
					<div className="py-3 grid gap-4 lg:gap-6 xl:gap-6 md:flex xl:flex">
						<div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
							<Input
								ref={userRef}
								className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
								type="search"
								name="search"
								placeholder="Quick Search"
								autoComplete="off"
								onChange={handleSubmitUser}
							/>
							<button
								type="submit"
								className="absolute right-0 top-0 mt-5 mr-1"
							></button>
						</div>
						<div className="items-center" style={{ paddingRight: '20px' }}>
							<Select
								style={{ marginLeft: 20 }}
								value={itemsPerPage}
								onChange={(event) => setItemsPerPage(event.target.value)}
							>
								<option value={10}>10 per page</option>
								<option value={20}>20 per page</option>
								<option value={50}>50 per page</option>
								<option value={100}>100 per page</option>
								<option value={data ? data.length : 0}>Show All</option>
							</Select>
						</div>
						<div className="items-center">
							<ExportDataExcelBE
								title="Vehicle"
								id_employee={adminInfo.id}
								extra="requestQueue/"
							/>
						</div>
						<div className="w-full md:w-56 lg:w-56 xl:w-56">
							<Button onClick={toggleDrawer} className="w-full rounded-md h-10">
								<span className="mr-3">
									<FiPlus />
								</span>
								Add Vehicle
							</Button>
						</div>
					</div>
				</CardBody>
			</Card>

			{loading ? (
				// <Loading loading={loading} />
				<TableLoading row={12} col={6} width={190} height={20} />
			) : serviceData?.length !== 0 ? (
				<TableContainer className="mb-8">
					<Table>
						<TableHeader>
							<tr>
								<TableCell>Sl.No.</TableCell>
								<TableCell>Vendor Name</TableCell>
								<TableCell>City</TableCell>
								<TableCell>Vehicle Name </TableCell>
								<TableCell>Vehicle No </TableCell>
								<TableCell>VehicleMFG Year </TableCell>
								<TableCell>Type of Query</TableCell>
								<TableCell className="text-right">Request</TableCell>
							</tr>
						</TableHeader>
						<RequestQueueTable
							vehicle={dataTable}
							perpage={itemsPerPage}
							currentPage={currentPage}
						/>
					</Table>
					<TableFooter>
						<Pagination
							totalResults={totalResults}
							resultsPerPage={resultsPerPage}
							onChange={handleChangePage}
							label="Table navigation"
						/>
					</TableFooter>
				</TableContainer>
			) : (
				<NotFound title="Sorry, There are no VehicleRequestQueue right now." />
			)}
		</>
	);
};

export default VehicleRequestQueue;
